import PropTypes from 'prop-types';

const EmptyState = ({ title, emptyMessage }) => (
  <div className="bg-gray-50/60 rounded-2xl p-6">
    <h4 className="font-semibold mb-4 text-gray-900">{title}</h4>
    <p className="text-gray-500">{emptyMessage}</p>
  </div>
);

EmptyState.propTypes = {
  title: PropTypes.string.isRequired,
  emptyMessage: PropTypes.string.isRequired,
};

export default EmptyState;
